<template>
    <v-container>
        <v-row>
            <v-col md="6" offset-md="3">
                <v-card>
                    <v-card-text>
                        <v-text-field
                            label="Username"
                            :value="loginUsername"
                            @input="setLoginUsername"
                        ></v-text-field>

                        <v-text-field
                            label="Contraseña"
                            type="password"
                            :value="loginPassword"
                            @input="setLoginPassword"
                        ></v-text-field>

                        <v-alert type="error" :value="loginError">
                            {{ loginError }}
                        </v-alert>

                        <v-btn color="indigo" @click="login">
                            Ingresar
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';

import router from '@/router/index';

export default {
    computed: {
        ...mapState('authentication', [
            'loginUsername',
            'loginPassword',
            'loginError',
            'currentUser',
            'action_root'
        ]),
    },
    methods: {
        ...mapMutations('authentication', [
            'setLoginUsername',
            'setLoginPassword',
            'setLoginError'
        ]),
        ...mapActions('authentication', [
            'login'
        ])
    },
    mounted() {
        if (this.action_root !== null) {
            router.push(this.action_root)
        }
    }
    
}
</script>

<style>

</style>